import React, { useEffect, useState ,useRef} from "react";
import axios from "../../../utils/fvAxios";
import BaseURL from "../../../utils/base-uri.json";
import { Box } from "@mui/material";
import ChecklistQuestionnaireContext from "./ChecklistQuestionnaireContext";
import Button from "../../../toolkit/ButtonV1";
import { toast } from "react-toastify";

const toastNotify = (message, isSuccess = true) => {
  if (isSuccess) {
    toast.success(message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  } else {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
};

export default function ChecklistTab({ pqId }) {
  const checkList = {};
  const [disabledButtons, setDisabledButtons] = useState({
    save: true,
    submit: true,
  });
  const [saveState, setSaveState] = useState(null);
  const [modifiedData, setModifiedData] = useState({});
  const [showSaveOrEditButton, setShowSaveEditButton] = useState(false);
  // const [validate, setValidate] = useState();
  const [validate, setValidate] = useState({});
  const [checklistActivityDetail, setChecklistActivityDetail] = useState({
    checklistActivityId: 0,
    clientTemplateId: "",
  });
  const [disableAllFields, setDisableAllFields] = useState(true);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(
    !!Object.keys(modifiedData).length
  );
  const ValidationsErrors = (columnId, value, subfield = 0) => {
    setValidate((prevValidate) => ({
      ...prevValidate,
      [columnId]:
        subfield !== 0
          ? {
              ...prevValidate[columnId],
              [subfield]: value,
            }
          : value,
    }));
  };
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    if (
      saveState?.status === "inProgress" ||
      saveState?.status === "submitting"
    ) {
      setDisabledButtons({
        prev: true,
        next: true,
        cancel: true,
        save: true,
        submit: true,
      });
    } else {
      setDisabledButtons({
        prev: hasUnsavedChanges,
        next: hasUnsavedChanges,
        cancel: !hasUnsavedChanges,
        save: !hasUnsavedChanges,
        submit: !hasUnsavedChanges,
      });
    }
  }, [saveState, hasUnsavedChanges]);

  useEffect(() => {
    setHasUnsavedChanges(!!Object.keys(modifiedData).length);
  }, [modifiedData]);

  // useEffect(() => {
  //   // GetLatestCheckListActivity();
  // }, []);

  // const GetLatestCheckListActivity = async () => {
  //   setDisableAllFields(false);
  //   const response = await axios.get(BaseURL.widget.LatestCheckListActivity + `pqId=${pqId}`);

  //   if (response.data?.data && response.data.data.checklistActivityId > 0) {
  //      setChecklistActivityDetail(response.data.data.checklistActivityId);
  //     //setOrgTypes(response.data.data?.orgTypes?.map(r => ({ value: r.value, text: r.text, selected: r.selected })))
  //   }
  // };
  const [fieldIdsAndInputTypes, setFieldIdsAndInputTypes] = useState([]);

  // const fieldIdsAndInputTypes= [{fieldId: 0, subFieldId: 0, inputType:" field.inputType"}];

  const validateUserInputs = (topLevelValue) => {
    if (typeof topLevelValue === "string") {
      // if (topLevelValue === null || topLevelValue === undefined || topLevelValue === '') {
      return (
        topLevelValue !== null &&
        topLevelValue !== undefined &&
        topLevelValue !== ""
      );

      //return true;
    } else if (Array.isArray(topLevelValue)) {
      return topLevelValue.length > 0 && !topLevelValue.includes("false");
    } else if (
      topLevelValue == null ||
      topLevelValue == undefined ||
      topLevelValue == ""
    ) {
      return false;
    } else if (typeof topLevelValue === "object") {
      return Object.values(topLevelValue).every((subfieldValue) => {
        return validateUserInputs(subfieldValue);
        //return subfieldValue !== null && subfieldValue !== undefined && subfieldValue !== '';
      });
    }
  };

  const validateChecklistInput = () => {
    return !Object.keys(validate).every((key) => {
      const field = fieldIdsAndInputTypes.find((x) => x.fieldId == key)?.field;
      const topLevelValue = validate[key];
      if (typeof topLevelValue === "string") {
        if (field?.inputType == "checkbox") {
          return topLevelValue.length > 0 && topLevelValue.includes("true");
        }
        return (
          topLevelValue !== null &&
          topLevelValue !== undefined &&
          topLevelValue !== ""
        );
      } else if (Array.isArray(topLevelValue)) {
        if (
          fieldIdsAndInputTypes.find((x) => x.fieldId == key)?.field
            ?.inputType == "checkbox"
        ) {
          return topLevelValue.includes("true");
        }
        return topLevelValue.length > 0 && !topLevelValue.includes("false");
      } else if (
        topLevelValue == null ||
        topLevelValue == undefined ||
        topLevelValue == ""
      ) {
        return false;
      } else if (typeof topLevelValue === "object") {
        const subFields = field?.subFields;
        return Object.values(topLevelValue).every((subfieldValue, index) => {
          if (subFields && subFields[index]?.inputType == "checkbox") {
            if (Array.isArray(subfieldValue)) {
              return subfieldValue.includes("true");
            } else {
              return (
                subfieldValue !== null &&
                subfieldValue !== undefined &&
                subfieldValue !== "" &&
                subfieldValue.includes("true")
              );
            }
          }

          return validateUserInputs(subfieldValue);
        });
      }
      return true;
    });
  };

  const saveChecklist = async () => {
    const details = modifiedData.flatMap((r) => {
      return r?.checklistSubSections.flatMap((subSection) => {
        return {
          checklistSubSectionId: subSection.checklistSubSectionId,
          isFinancialAnalytics: subSection.isFinancialAnalytics,
          userInputRequests: subSection.checklistQuestions.flatMap((q) => {
            return q?.checklistQuestionColumnDetails.map((c) => {
              let userInput = c.answer;
              if (Array.isArray(userInput)) {
                userInput = userInput.join("|");
              }
              let oldUserInput = c.OldUserInput;
              if (Array.isArray(oldUserInput)) {
                oldUserInput = oldUserInput.join("|");
              }

              return {
                checkListUserInputId: c.checkListUserInputId,
                checklistQuestionColumnDetailId:
                  c.checklistQuestionColumnDetailsId,
                userInput: userInput,
                oldUserInput: oldUserInput,
                referenceId: 0,
                linkToComment: c.linkToComment,
              };
            });
          }),
        };
      });
    });

    const userInputData = {
      PrequalificationId: +pqId,
      CheckLists: details,
    };
    const saveResp = await axios.post(
      BaseURL.baseUrl + BaseURL.widget.SaveCheckList,
      userInputData
    );
    setSaveState(saveResp?.data?.data);

    if (saveResp?.data?.data === "Saved Successfully") {
      setRefresh(!refresh);
      setHasUnsavedChanges(false);
      toastNotify(saveResp?.data?.data);
    } else {
      toastNotify(saveResp?.data?.data, false);
    }
  };

  const onSaveChecklistData = async () => {
    setSaveState({ status: "inProgress" });
    await saveChecklist();
  };

  const onSubmitChecklistData = async () => {
    if (validateChecklistInput()) {
      toastNotify("Please fill all the required fields", false);
      return;
    }
    setSaveState({ status: "submitting" });
    await saveChecklist();
  };

  const onGetChecklistHandler = (hasChecklist, latestChecklistActivity) => {
    setShowSaveEditButton(hasChecklist);
    if (latestChecklistActivity) {
      setChecklistActivityDetail(latestChecklistActivity);
      //setOrgTypes(response.data.data?.orgTypes?.map(r => ({ value: r.value, text: r.text, selected: r.selected })))
    }
  };
  const onStartEditCheckList = async () => {
    const activity = {
      PrequalificationId: +pqId,
      ClientTemplateId: checklistActivityDetail.clientTemplateId,
    };
    const resp = await axios.post(
      BaseURL.baseUrl + BaseURL.widget.AddOrUpdateCheckListActivity,
      activity
    );
    if (resp.data?.responseCode == 100) setDisableAllFields(false);
    else {
      toastNotify("Error fetching information", false);
    }
  };
  const validateAllSubSectionQuestions = (data) => {
    const updatedFieldIdsAndInputTypes = [];

    data.forEach((question) => {
      question.forEach((field) => {
        if (field.required && field.isLinked == false) {
          ValidationsErrors(field.id, field.userResponse);
          updatedFieldIdsAndInputTypes.push({
            fieldId: field.id,
            subFieldId: 0,
            inputType: field.inputType,
            field: { ...field },
          });
        } else {
          field.subFields?.forEach((subField) => {
            if (subField.inputType !== "button" && subField.required) {
              updatedFieldIdsAndInputTypes.push({
                fieldId: field.id,
                subFieldId: subField.id,
                inputType: subField.inputType,
                field: { ...field },
              });
              ValidationsErrors(field.id, subField.userResponse, subField.id);
            }
          });
        }
      });
    });
    setFieldIdsAndInputTypes(updatedFieldIdsAndInputTypes);
  };


  const boxRef = useRef(null); // Ref to track the Box component
  const [boxHeight, setBoxHeight] = useState(0); // State to store the height

  useEffect(() => {
    if (boxRef.current) {
      // Set the initial height
      setBoxHeight(boxRef.current.offsetHeight);
    }

    const handleResize = () => {
      if (boxRef.current) {
        // Update the height when the window is resized
        setBoxHeight(boxRef.current.offsetHeight);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // This effect runs every time the boxHeight changes
 
  }, [boxHeight]);

  return (
    <>
      <Box px={2} templateid={checklistActivityDetail?.templateId}>
        {showSaveOrEditButton && disableAllFields && (
          <Box className="p-3 border-1 bg-white w-100">
            <Button
              disabled={false}
              role="primary"
              size="small"
              className={`py-4 w-100`}
              onClick={onStartEditCheckList}
              label={`${
                checklistActivityDetail.checklistActivityId > 0
                  ? "Edit"
                  : "Start"
              } `}
            />
          </Box>
        )}
      </Box>
      <Box px={2} >
        <ChecklistQuestionnaireContext
          dataUrl={""}
          setShowFormButtons={() => {}}
          reset={false}
          resetButtons={false}
          hasUnsavedChanges={hasUnsavedChanges}
          setReset={() => {}}
          Secid={0}
          SubId={checkList?.checklistDetailsid}
          IsSubSectionCompleted={checkList?.isSubSectionCompleted}
          SectionType={"SectionType"}
          SubSectionTypeCondition={checkList?.SubsectiontypeCondition}
          setModifiedData={setModifiedData}
          Validate={ValidationsErrors}
          RESETQUESTIONS={() => {}}
          title={checkList?.checklistName}
          content={checkList?.content}
          PAY={() => {}}
          SubSectionName={checkList?.checklistName}
          Triger={() => {}}
          VIEWMODE={"VIEWMODE"}
          QuestionReset={() => {}}
          ClientTemplate={null}
          pqId={pqId}
          onGetChecklist={onGetChecklistHandler}
          disableAll={disableAllFields}
          refresh={refresh}
          validateAllSubSectionQuestions={validateAllSubSectionQuestions}
          h1={boxHeight}
        />
   
      </Box>
    
      {showSaveOrEditButton && (
        <Box
        ref={boxRef}
          style={{ zIndex: "99" }}
          className="p-4 border-top border-1 position-absolute bottom-0 bg-white w-100"
        >
          <Button
            disabled={disabledButtons.save || disabledButtons.submit}
            role="primary"
            size="small"
            className="py-4 me-1"
            style={{ width: "49%" }}
            onClick={onSaveChecklistData}
            label={`${
              saveState?.status === "inProgress" ? "Saving..." : "Save"
            } `}
          />
          <Button
            disabled={disabledButtons.save || disabledButtons.submit}
            role="primary"
            size="small"
            className="py-4 ms-1"
            style={{ width: "49%" }}
            onClick={onSubmitChecklistData}
            label={`${
              saveState?.status === "submitting" ? "Submitting..." : "Submit"
            } `}
          />
        </Box>
      )}
    </>
  );
}
